/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Row_DeliveryInputs */

const en_wb_operations_row_delivery = /** @type {(inputs: Wb_Operations_Row_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requested delivery`)
};

const lv_wb_operations_row_delivery = /** @type {(inputs: Wb_Operations_Row_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vēlamā piegāde`)
};

/**
* | output |
* | --- |
* | "Requested delivery" |
*
* @param {Wb_Operations_Row_DeliveryInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_row_delivery = /** @type {((inputs?: Wb_Operations_Row_DeliveryInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Row_DeliveryInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_row_delivery(inputs)
	return en_wb_operations_row_delivery(inputs)
});